/**
 * @file LandingBody.jsx
 * @location src/components/landing/LandingBody.jsx
 * @role LP 본문 — 한국 1인 SaaS 컴팩트 톤. 기능 3카드 / 요금 / FAQ / 클로징 4섹션.
 *   히어로(가치 + 데모 스크린샷)는 LandingScreen 상단이 담당. 통증 제기·컨셉·신뢰·도입 흐름 섹션은
 *   한국 표준 1인 SaaS LP(Linear/Cal.com/Notion KR 스타일) 톤으로 의도적 제거.
 *   콘텐츠는 전부 실제 출시 기능 기반(도입 실적·후기 등 가짜 사회적 증거 없음). onStart = 무료 체험 CTA.
 */

const FEATURES = [
  {
    n: 1,
    t: '핸드셰이크',
    d: '보낸 업무는 「읽음」으로 도착, 「완료」로 돌아옵니다. 승인 버튼·진척률 없이 상태는 두 단계.',
    tl: '안 읽음 → 읽음 → 완료',
  },
  {
    n: 2,
    t: '루틴 자동 할당',
    d: '매일·매주·매월 반복 업무를 등록하면 그날 자동 발신. 격주·N번째 요일 같은 세부 지정도 지원.',
    tl: '아침 복붙 할당 제로',
  },
  {
    n: 3,
    t: '부하 가시화',
    d: '보내기 전에 멤버별 미완료 건수가 보입니다. 누가 비어 있는지 보고 할당해, 한 사람에게 몰리지 않습니다.',
    tl: '감시 아닌, 할당 판단 자료',
  },
];

const FAQS = [
  {
    q: '슬랙·카카오워크·잔디 같은 채팅 도구와 뭐가 달라요?',
    a: '채팅은 「말이 흐르는 곳」이고, 온점은 「업무가 도착·완료되는 곳」입니다. 채팅을 대체하는 게 아니라, 채팅으로는 메울 수 없는 「전달됐는지·끝났는지」의 어긋남을 구조로 없앱니다.',
  },
  {
    q: '지금 베타는 비용이 드나요?',
    a: '아니요. 지금은 무료 오픈베타입니다. 카드 등록·결제 없이 모든 기능을 그대로 쓸 수 있어요. 정식 요금제는 출시 시 따로 안내합니다.',
  },
  {
    q: '몇 명까지 쓸 수 있나요?',
    a: '베타 기간에는 정원 제한 없이 팀을 충분히 운영하며 평가해 보실 수 있습니다. 정식 출시 후에도 매니저 1인분만 과금하고 멤버 추가 비용은 없는 정액제로 운영할 예정입니다.',
  },
  {
    q: '모바일에서도 잘 되나요?',
    a: '네. 모바일 최우선으로 설계됐고, 홈 화면에 추가하면 앱처럼 작동합니다(PWA 지원).',
  },
  {
    q: '데이터는 안전한가요?',
    a: '통신은 SSL/TLS 암호화, 데이터는 팀 단위 권한으로 격리됩니다. 탈퇴 후에도 30일간 복원할 수 있습니다.',
  },
];

/** @param {{ onStart: () => void }} props */
export function LandingBody({ onStart }) {
  return (
    <>
      <section className="lp-sec" id="lp-feat">
        <div className="lp-wrap">
          <div className="lp-sec-head">
            <div className="kicker">기능</div>
            <h2>군더더기 없이, 3가지로 끝납니다.</h2>
          </div>
          <div className="lp-bento">
            <div className="lp-bento-card wide">
              <div className="lp-bento-txt">
                <h3>핸드셰이크</h3>
                <p>보낸 업무는 「읽음」으로 도착, 「완료」로 돌아옵니다. 승인 버튼·진척률 없이 상태는 두 단계.</p>
                <span className="tl">안 읽음 → 읽음 → 완료</span>
              </div>
              <div className="lp-bento-viz lp-bv-flow" aria-hidden="true">
                <span className="lp-pill unread">안 읽음</span>
                <i className="lp-bv-arrow">→</i>
                <span className="lp-pill read">읽음</span>
                <i className="lp-bv-arrow">→</i>
                <span className="lp-pill done">완료</span>
              </div>
            </div>

            <div className="lp-bento-card">
              <div className="lp-bento-viz lp-bv-cal" aria-hidden="true">
                {['월','화','수','목','금','토','일'].map((d, i) => (
                  <span key={d} className={`lp-bv-day${[0, 2, 4].includes(i) ? ' on' : ''}`}>{d}</span>
                ))}
              </div>
              <h3>루틴 자동 할당</h3>
              <p>매일·매주·매월 반복 업무를 등록하면 그날 자동 발신. 격주·N번째 요일까지.</p>
              <span className="tl">아침 복붙 할당 제로</span>
            </div>

            <div className="lp-bento-card">
              <div className="lp-bento-viz lp-bv-load" aria-hidden="true">
                <div className="lp-lrow"><span className="nm">변새봄</span><span className="lp-pill unread">미완료 5건</span></div>
                <div className="lp-lrow"><span className="nm">마윤슬</span><span className="lp-pill read">미완료 2건</span></div>
                <div className="lp-lrow"><span className="nm">선우라온</span><span className="lp-pill done">여유</span></div>
              </div>
              <h3>부하 가시화</h3>
              <p>보내기 전에 멤버별 미완료 건수가 보입니다. 누가 비어 있는지 보고 할당.</p>
              <span className="tl">감시 아닌, 할당 판단 자료</span>
            </div>
          </div>
        </div>
      </section>

      <section className="lp-sec alt" id="lp-beta">
        <div className="lp-wrap">
          <div className="lp-sec-head">
            <div className="kicker">베타</div>
            <h2>지금은 무료 오픈베타입니다.</h2>
          </div>
          <div className="lp-price-grid" style={{ justifyContent: 'center' }}>
            <div className="lp-price-card" style={{ maxWidth: 440 }}>
              <div className="lp-plan-name">무료 오픈베타</div>
              <div className="lp-price">0원<small>/베타 기간</small></div>
              <div className="lp-price-sub" style={{ color: 'var(--g)', fontWeight: 600, marginBottom: 22 }}>카드 등록·결제 없음</div>
              <ul className="lp-plist">
                <li>모든 기능 무료</li>
                <li>정원 제한 없이 팀 운영·평가</li>
                <li>매니저 1명 + 팀원 무제한</li>
                <li>정식 요금제는 출시 시 안내</li>
              </ul>
              <button className="lp-btn-primary lg" style={{ width: '100%' }} onClick={onStart}>무료로 시작</button>
            </div>
          </div>
          <div className="lp-price-note" style={{ textAlign: 'center', marginTop: 20 }}>
            카드 등록 없이 1분 시작 · 탈퇴 후 30일 데이터 복원<br />
            함께 다듬는 베타입니다 — 피드백은 support@onjeom.com 로 환영합니다.
          </div>
        </div>
      </section>

      <section className="lp-sec" id="lp-faq">
        <div className="lp-wrap">
          <div className="lp-sec-head">
            <div className="kicker">FAQ</div>
            <h2>자주 묻는 질문.</h2>
          </div>
          <div className="lp-faq">
            {FAQS.map((f) => (
              <div className="lp-qa" key={f.q}>
                <h4><span className="q">Q.</span>{f.q}</h4>
                <p>{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="lp-sec lp-closing">
        <div className="lp-wrap">
          <h2>지금은 무료 베타. 카드 없이 바로.</h2>
          <p>1분이면 시작합니다.</p>
          <button className="lp-btn-primary lg" onClick={onStart}>무료로 시작</button>
        </div>
      </section>
    </>
  );
}
